import { render, staticRenderFns } from "./MaterialTemplateEdit.vue?vue&type=template&id=24df81b8&"
import script from "./MaterialTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports